import { render, staticRenderFns } from "./PersonalQuestions.vue?vue&type=template&id=76718ad6&"
import script from "./PersonalQuestions.vue?vue&type=script&lang=js&"
export * from "./PersonalQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports